module.exports = __webpack_public_path__ + "img/dsci0137.b8ddb2f6.jpg";